import DolfinRecord from '../../record'
import { Enums } from '../../db_types'
import { DOLFIN_DSL_MATCHERS } from './utils/matchers'

export abstract class DolfinParser {
  constructor(
    protected recordData: DolfinRecord,
    protected matcher?: RegExp,
    protected outcomePeriod?: Enums<'period'>
  ) {
  }

  protected getTags(formula: string) {
    return formula.trim().split(/\s+(?=(?:[^']*'[^']*')*[^']*$)/)
  }

  protected joinFunctionArguments(formula: string) {
    const tags = this.getTags(formula)

    tags.forEach(tag => {
      if (this.matcher?.test(tag)) {
        const tagIndex = tags.indexOf(tag)
        const operatorIndex = tags
          .slice(tagIndex)
          .findIndex(tag => RegExp(DOLFIN_DSL_MATCHERS.OPERATOR).exec(tag))

        // If there are no operators after the function, then the function is the last element in the array
        if (operatorIndex === -1) {
          const functionArgs = tags.slice(tagIndex + 1, tags.length)
          tags.splice(
            tagIndex,
            tags.length - tagIndex,
            tag + ' ' + functionArgs.join(' ')
          )
        } else {
          const operator = tags[tagIndex + operatorIndex]
          const functionArgs = tags.slice(
            tagIndex + 1,
            tagIndex + operatorIndex
          )
          tags.splice(
            tagIndex,
            operatorIndex + 1,
            tag + ' ' + functionArgs.join(' '),
            operator
          )
        }
      }
    })

    return tags
  }

  execute(_formula: string): string {
    throw new Error('Method not implemented.')
  }
}
